export default "__VITE_ASSET__VA64NXS4__"